import {useState, useMemo, useCallback} from 'react'
import {sidebarConfig} from '../../constants/sidebarConfig'
import {EditorConfig} from '../../constants/editorConfig'
import {addNode} from '../../editorActions'

/**
 * @param {{ dispatch: Function, devTools?: object } | null} runtime
 * @param {{ onAddImage?: () => void }} [options]
 * @returns {{ items: object[], activeItem: string | null, onItemClick: (item: object) => void }}
 */
export function useSidebar(runtime, options = {}) {
    const [activeItem, setActiveItem] = useState(null)

    const items = useMemo(() => {
        return sidebarConfig.filter((item) => {
            if (item.visibleWhen === 'devTools') {
                return runtime?.devTools != null
            }
            return true
        })
    }, [runtime?.devTools])

    const onItemClick = useCallback(
        (item) => {
            if (!runtime) return

            if (item.panelId != null) {
                setActiveItem((prev) => (prev === item.panelId ? null : item.panelId))
                return
            }

            switch (item.action) {
                case 'addImage': {
                    if (typeof options.onAddImage === 'function') {
                        options.onAddImage()
                        break
                    }
                    const id = Date.now().toString()
                    runtime.dispatch(addNode({...EditorConfig.DEFAULT_IMAGE_NODE, id}, 0, true))
                    break
                }
                case 'addText': {
                    const id = Date.now().toString()
                    runtime.dispatch(addNode({...EditorConfig.DEFAULT_TEXT_NODE, id}, 0, true))
                    break
                }
                default:
                    break
            }
        },
        [runtime, options.onAddImage],
    )

    return {items, activeItem, onItemClick}
}
